export enum UserRoleEnum {
    recepcao_fora_ordem = 6,
    config_sector_visualizar = 81,
    config_sector_alterar = 82,
    cancelar_agendamento = 311,
    requerer_assinatura_classificacao = 322,
    requerer_assinatura_medico = 337,
    requerer_assinatura_medico_gestao_leitos = 351,
    requerer_assinatura_multiprofissional = 352,
    requerer_assinatura_observacao = 353,
    requerer_assinatura_observacao_gestao_leitos = 354,
    requerer_assinatura_recepcao = 355,
    checar_atrasado_com_restrição = 396,
    liberador_checar_atrasado_com_restrição = 397,
    checagem_suspender_horário = 398,
    therapy_scheduling_nurse_can_suspended = 405,
    master_painel_alterarPin = 406,
    //alterar depois
    requerer_assinatura_basic_care = 800,
    visualizar_exames = 414,
}